import React from 'react'

export default function Spinner({classes}) {
    return (
        <span className={`new-loader ${classes}`}></span>  
        )
}
